import { Card, Typography } from "antd";
import styles from "../../../deliveryServices/DeliveryServices.module.css";

const { Text } = Typography;

function InProgressCard({ date }) {
  return (
    <Card className={styles.dsCardStyle}>
      <Text className={styles.dsCardTitle}>Onboarding Request Submitted</Text>
      <p className={styles.dsCardDate}>{date}</p>
      <p className={styles.dsFormLabels}>
        Processing may take up to 24 hours or longer.
      </p>
      <p className={styles.dsFormLabels}>
        If you need assistance, reach out to Customer Service at{" "}
        <b>(818) 235-1327</b>.
      </p>
    </Card>
  );
}

export default InProgressCard;
